export default __webpack_public_path__ + "static/media/avatarsupplier.3a23b843.svg";